<template>
  <div class="container">
      <div class="mianView">
            <div class="topmianBG">
                <img class="topmianBG_image" src="../../../assets/images/environmentalBG.jpg" />
            </div>
            <div class="bodyBg">
                <div class="topMian">
                    <div class="topMian_div1">
                        <span class="topMian_div1_text1">优</span>
                        <div class="topMian_div1_right">
                            <div class="topMian_div1_right_item">
                                <span class="topMian_div1_right_item_text1">温度: </span>
                                <span class="topMian_div1_right_item_text2">20℃</span>
                            </div>
                            <div class="topMian_div1_right_item">
                                <span class="topMian_div1_right_item_text1">湿度: </span>
                                <span class="topMian_div1_right_item_text2">62%</span>
                            </div>
                        </div>
                    </div>

                    <div class="topMian_div2">
                        <div class="topMian_div2_icon"></div>
                        <span class="topMian_div2_text1">室内环境评分 </span>
                        <span class="topMian_div2_text2">98</span>
                        <span class="topMian_div2_text1"> ，今天环境很好哦~</span>
                    </div>

                    <div class="topMianTime">
                        <span class="topMianTime_span">3月9日 周一</span>
                    </div>

                </div>


                <div class="tableView">
                    <div class="tableTop">
                        <span class="tableTop_text1">历史数据</span>
                        <span class="tableTop_text2">过去7天</span>
                    </div>
                    <div class="SegmentedViewBg">
                        <div class="SegmentedView">
                            <span @click="changeSelect(0)" :class="['SegmentedItem0',selectIndex==0?'SegmentedItemSelect':'']">温度</span>
                            <span @click="changeSelect(1)" :class="['SegmentedItem1',selectIndex==1?'SegmentedItemSelect':'']">湿度</span>
                            <span @click="changeSelect(2)" :class="['SegmentedItem2',selectIndex==2?'SegmentedItemSelect':'']">PM2.5</span>
                            <span @click="changeSelect(3)" :class="['SegmentedItem3',selectIndex==3?'SegmentedItemSelect':'']">TVOC</span>
                            <span @click="changeSelect(4)" :class="['SegmentedItem4',selectIndex==4?'SegmentedItemSelect':'']">二氧化碳</span>
                            <span @click="changeSelect(5)" :class="['SegmentedItem5',selectIndex==5?'SegmentedItemSelect':'']">甲醛</span>
                        </div>
                    </div>
                    <!-- <div class="tableUitl">
                        <span class="tableUitl_text">单位(℃)</span>
                    </div> -->
                    <div class="lineTableBody">
                         <chart-line :data-list="lineData" :xData="xData" :extra-option="optionLine" />
                    </div>
                </div>

                <div class="bangongArea">
                     <div class="bangongAreaTop">
                        <span class="tableTop_text1">区域数据</span>
                        <span class="tableTop_text2">共5个区域</span>
                    </div>

                    <div class="bangongArea_item" v-for="(item,index) in areaList" :key="index">
                        <img  class="bangongArea_item_bg" src="../../../assets/images/area_1.jpg" />
                        <div class="bangongArea_item_body">
                            <span class="bangongArea_item_body_topSpan">办公区域1</span>
                            <div class="bangongArea_item_body_div">
                                <div class="bangongArea_item_body_dot"></div>
                                <span class="bangongArea_item_body_span">温度: 20℃</span>
                                <img class="bangongArea_item_body_icon" src='../../../assets/images/icon_down_green.png' />
                            </div>
                            <div class="bangongArea_item_body_div">
                                <div class="bangongArea_item_body_dot"></div>
                                <span class="bangongArea_item_body_span">湿度: 61%</span>
                                <img class="bangongArea_item_body_icon" src='../../../assets/images/icon_down_green.png' />
                            </div>
                            <div class="bangongArea_item_body_div">
                                <div class="bangongArea_item_body_dot"></div>
                                <span class="bangongArea_item_body_span">PM2.5: 11(μg/m³)</span>
                                <img class="bangongArea_item_body_icon" src='../../../assets/images/icon_down_green.png' />
                            </div>
                            <div class="bangongArea_item_body_div">
                                <div class="bangongArea_item_body_dot"></div>
                                <span class="bangongArea_item_body_span">TVOC: 0.05(mg/m³)</span>
                                <img class="bangongArea_item_body_icon" src='../../../assets/images/icon_down_green.png' />
                            </div>
                            <div class="bangongArea_item_body_div">
                                <div class="bangongArea_item_body_dot"></div>
                                <span class="bangongArea_item_body_span">甲醛: 0.04(mg/m³)</span>
                                <img class="bangongArea_item_body_icon" src='../../../assets/images/icon_down_green.png' />
                            </div>
                            <div class="bangongArea_item_body_div">
                                <div class="bangongArea_item_body_dot"></div>
                                <span class="bangongArea_item_body_span">温度: 20℃</span>
                                <img class="bangongArea_item_body_icon" src='../../../assets/images/icon_down_green.png' />
                            </div>
                        </div>
                    </div>
                </div>
           </div>
      </div>
  </div>
</template>
<script>
import util from "@/utils/util";
import ChartLine from "@/components/echarts/echart_line/EchartLine.vue";
import echart from "echarts";
import {calendarReport} from "@/utils/api";
import {mapState} from 'vuex';
export default {
    data(){
        return {
            newDate:'',
            selectIndex:0,
             xData:['03-01', '03-02', '03-03', '03-04', '03-05', '03-06', '03-07'],
             lineData: [{
                        name: '温度',
                        data: [24.5, 26, 25, 23, 30, 28, 25],
                        type: 'line',
                        smooth: 0.5,// 设置折线弧度，取值：0-1之间
                        symbol:'circle',// 设置拐点为实心圆
                        symbolSize:2,// 设置折线上圆点大小
                        areaStyle: {
                            color: new echart.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(245, 200, 22, 1)',
                            }, {
                                offset: 1,
                                color: 'rgba(245, 200, 22, 0)'
                            }])
                        },
                    },
             ],
              optionLine: {
                        color:['#F5C816',],
                         title: {
                            text: '单位(℃)',
                         }
              },
              areaList:[1,2,3,4,5],

        }
    },
    components:{
        ChartLine,
    },
    computed: {
        ...mapState({
        common: state => state.common
        })
    },
    created(){

    },
     methods:{
         changeSelect(index){
            this.selectIndex =index;
         }

    }
}
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.container{
   // height:100vh;
    background:#FFFFFF;
}

.mianView{
  //  position:absolute;
    width: 100%;
    background-color:#FFFFFF;
    position: relative;
}
.topmianBG{
    position:absolute;
    // background-color: #FAFAFA;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 390px;
    z-index: 1;
}
.topmianBG_image{
    width: 100%;
    height: 390px;
}
.bodyBg{
     position:absolute;
     flex-direction: column;
    left: 0px;
    top: 0px;
    width: 100%;
    z-index: 100;
}
.topMian{
    display: flex;
    position: relative;
    width: 100%;
    height: 324px;
    z-index: 100;
    flex-direction: column;
}
.topMianTime{
    position:absolute;
    top: 28px;
    right: 28px;
}
.topMianTime_span{
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(94,119,140,1);
    line-height:40px;
}
.topMian_div1{
    margin-left: 40px;
    margin-top: 20px;
    width: 710px;
    display: flex;
    flex-direction: row;
}

.topMian_div1_text1{
    display: flex;
    height:196px;
    font-size:140px;
    font-weight:400;
    color:rgba(35,71,101,1);
    line-height:196px;
}
.topMian_div1_right{
    margin-top: 62px;
    margin-left: 40px;
    flex-direction: column;
}
.topMian_div1_right_item{
    flex-direction: row;
    margin-bottom: 14px;
}

.topMian_div1_right_item_text1{
    height:44px;
    font-size:32px;
    font-weight:400;
    color:rgba(94,119,140,1);
    line-height:44px;
}
.topMian_div1_right_item_text2{
    margin-left: 14px;
    height:44px;
    font-size:32px;
    font-weight:400;
    color:rgba(35,71,101,1);
    line-height:44px;

}

.topMian_div2{

    padding-left: 20px;
    padding-right: 20px;
    height:68px;
    background:rgba(255,255,255,0.7);
    border-radius:40px;
     flex-direction: row;
     display: flex;
    align-items: center;

}
.topMian_div2_icon{
    width: 40px;
    height: 40px;
    margin-right: 10px;
    background-color: red;
}
.topMian_div2_text1{
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(35,71,101,1);
    line-height:40px;
}
.topMian_div2_text2{
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(27,190,135,1);
    line-height:40px;

}

.tableView{
    width: 100%;
    // margin-top: 60px;
    flex-direction: column;
}
.tableTop{
    width:100%;
    height:100px;
    display: flex;
    background:rgba(255,255,255,1);
    // box-shadow:0px -8px 32px 0px rgba(0,0,0,0.06);
    border-radius:40px 40px 0px 0px;
    justify-content: space-between;
    align-items: center;
}
.tableTop_text1{
    margin-left: 28px;
    height:50px;
    font-size:36px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:50px;

}
.tableTop_text2{
    margin-right: 28px;
    height:36px;
    font-size:26px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:36px;
}
.SegmentedViewBg{
    width:100%;
    width: 68px;
    background:rgba(255,255,255,1);
}
.SegmentedView{
    margin-left: 28px;
    display: flex;
    margin-top: 12px;
    width: 620px;
     flex-direction: row;
     position: relative;
}
.SegmentedItem0{
    position:absolute ;
    left: 0px;
    width:100px;
    height:44px;
    text-align: center;
    border-radius:8px 0px 0px 8px;
    border:1px solid rgba(234,234,234,1);
    border-top-width: 2px;
    border-bottom-width: 2px;
    font-size:24px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:44px;
    z-index: 1;
}

.SegmentedItem1{
    position:absolute ;
    left: 100px;
    width:100px;
    height:44px;
    text-align: center;
    border:1px solid rgba(234,234,234,1);
    border-top-width: 2px;
    border-bottom-width: 2px;
    font-size:24px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:44px;
    z-index: 2;
}
.SegmentedItem2{
    position:absolute ;
    left: 200px;
    width:100px;
    height:44px;
    text-align: center;
    border:1px solid rgba(234,234,234,1);
    border-top-width: 2px;
    border-bottom-width: 2px;
    font-size:24px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:44px;
    z-index: 3;
}
.SegmentedItem3{
    position:absolute ;
    left: 300px;
    width:100px;
    height:44px;
    text-align: center;
    border:1px solid rgba(234,234,234,1);
    border-top-width: 2px;
    border-bottom-width: 2px;
    font-size:24px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:44px;
    z-index: 3;
}
.SegmentedItem4{
    position:absolute ;
    left: 400px;
    width:110px;
    height:44px;
    text-align: center;
    border:1px solid rgba(234,234,234,1);
    border-top-width: 2px;
    border-bottom-width: 2px;
    font-size:24px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:44px;
    z-index: 3;
}
.SegmentedItem5{
    position:absolute ;
    left: 510px;
    width:100px;
    height:44px;
    text-align: center;
    border-radius:0px 8px 8px 0px;
    border:1px solid rgba(234,234,234,1);
    border-top-width: 2px;
    border-bottom-width: 2px;
    font-size:24px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:44px;
    z-index: 4;
}
.SegmentedItemSelect{
    // width:100px;
    z-index: 100;
    border:2px solid rgba(23,64,218,1);
    color:rgba(23,64,218,1);
}

.tableUitl{
    margin-top: 16px;
    margin-bottom: 8px;
    flex-direction: row;
}
.tableUitl_text{
    margin-left: 28px;
    height:32px;
    font-size:22px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:32px;
}

.lineTableBody{
     margin-top: 40px;
    width: 100%;
    height: 344px;
}
.bangongArea{
    width: 100%;
    // margin-top: 60px;
    flex-direction: column;

}
.bangongAreaTop{
     width:100%;
    height:90px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

}
.bangongArea_item{
    display: flex;
    position: relative;
    width:694px;
    height:400px;
    margin-left: 28px;
    margin-bottom: 28px;
    margin-right: 28px;
}
.bangongArea_item_bg{
    position:absolute;
     width:694px;
    height:400px;
    z-index: 1;
}
.bangongArea_item_body{
    display: flex;
    position:absolute;
    flex-direction: column;
    width:694px;
    height:400px;
    z-index: 100;
}
.bangongArea_item_body_topSpan{
    margin-left: 28px;
    margin-top: 28px;
    margin-bottom: 34px;
    height:44px;
    font-size:32px;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:44px;

}
.bangongArea_item_body_div{
    flex-direction: row;
    width: 100%;
    display: flex;
    margin-bottom: 10px;
    align-items: center;
}
.bangongArea_item_body_dot{
    width:12px;
    height:12px;
    margin-left: 28px;
    border-radius: 6px;
    background:rgba(22,188,132,1);
}
.bangongArea_item_body_span{
    height:34px;
    font-size:24px;
    margin-left: 12px;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:34px;
}
.bangongArea_item_body_icon{
    width: 28px;
    height: 28px;
    margin-left: 12px;
}

</style>